import { InputAdornment } from '@mui/material';
import { FC } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface InputAdornmentComponentProps {
  errorCondition: boolean;
}

const InputAdornmentComponent: FC<InputAdornmentComponentProps> = ({
  errorCondition,
}) => {
  return (
    <InputAdornment position='end'>
      {errorCondition ? <ErrorOutlineIcon color='error' /> : <></>}
    </InputAdornment>
  );
};
export default InputAdornmentComponent;
